import midAutumn from '@/views/act/midAutumnAccum2026/assets/locales/th.js'
import halloween from '@/views/act/halloween/assets/locale/th.js'
export default {
  midAutumn,
  halloween,
  "props": {
    "90501249": "ฉายา – เติมสุขใต้แสงจันทร์",
    "10101048": "Groza-ยูนิคอร์นสายรุ้ง (7 วัน)",
    "10101059": "M762 จิ้งจอกงามลึกลับ (7 วัน)",
    "70100004": "ตั๋วแลกซื้อ",
    "70100101": "เพชรทอง",
    "80102101": "ตั๋วจับรางวัล เพชรทอง",
    "80202003": "บัตรอัปเกรดอาวุธระดับ 3",
    "1010504001": "P90-ดอกไม้เหี่ยวเฉา (5 วัน)",
    "80103001": "บัตรป้องกันอันดับ",
    "80103002": "บัตรเพิ่มคะแนนอันดับสองเท่า",
    "70100011": "เหรียญทอง",
    "70100014": "กุญแจสมบัติลับ",
    "81010999": "เหรียญเติบโตครอบจักรวาล",
    "70100013": "คูปองสมบัติลับ",
    "50120500": "บึงกลางฤดูร้อน: ต้นอ่อนที่ถูกแต่งแต้ม",
    "90301912": "[กรอบโปรไฟล์] รวยไม่ไหวแล้ววว",
    "90501246": "[ฉายา] รวยไม่ไหวแล้ววว",
    "90301913": "[กรอบโปรไฟล์] ป๊ะป๋ามหาเปย์",
    "90501247": "[ฉายา] ป๊ะป๋ามหาเปย์",
    "90301914": "[กรอบโปรไฟล์] เจ้าพ่อเศรษฐี",
    "90501248": "[ฉายา] เจ้าพ่อเศรษฐี",
    "70100012": "อัญมณีลับ",
    "32701009": "แพ็คเกจพรีเมียมเต็มรูปแบบ"
  },
  "payment": {
    "popupEvent": {
      "joinImmediate": "เข้าร่วมเลย",
      "noMoreTip": "ไม่ต้องเตือนฉันอีกในวันนี้"
    },
    "videoIntro": "เพชรรุ้งคือสกุลเงินในเกม สามารถใช้จ่ายซื้อของต่างๆ ในเกมได้เลยโดยไม่ต้องจ่ายเงินเพิ่ม!\n\nมูลค่าของเพชรรุ้งเท่ากับเงินสดในเกม แถมการซื้อเพชรรุ้งจะได้รับโบนัสแถมเพิ่มด้วย!\n\nตัวอย่าง: แพ็กเกจมูลค่า 399บาท ในเกม สามารถซื้อได้โดยใช้เพชรรุ้งมูลค่า 399บาท และการเติมเพชรรุ้งมูลค่า 399บาท จะได้รับโบนัสเพิ่มอีก 10%\n\nเคล็ดลับ: การเติมเพชรรุ้งครั้งแรกจะได้รับโบนัสสูงสุด 100%!",
    "post": {
      "title": "เนื้อหาเพิ่มเติม",
      "announcement": "ประกาศ",
      "faq": "คำถามที่พบบ่อย"
    },
    "howToCheckUserId": "วิธีเช็คไอดีตัวละคร",
    "title": "การเติมเงินอย่างเป็นทางการ, รางวัลโบนัส!",
    "noData": "ไม่มีข้อมูล",
    "tip": "เตือนความจำ",
    "notStart": "กิจกรรมยังไม่เริ่ม",
    "ended": "สิ้นสุดแล้ว",
    "maintainTip": "ช่องทางการชำระเงินนี้กำลังอยู่ระหว่างการบำรุงรักษา กรุณาลองอีกครั้งในภายหลัง",
    "validateUser": {
      "title": "ตรวจสอบแอคเค้าท์",
      "enterUserId": "กรุณากรอกรหัสตัวละครของคุณ",
      "desc": "รหัสตัวละคร",
      "submit": "ยืนยัน",
      "noUserText": "กรุณาค้นหาและยืนยันข้อมูลของคุณก่อน",
      "queryLimitExceeded": "มีคำขอมากเกินไป โปรดลองใหม่ภายหลัง",
      "userNotFound": "รหัสตัวละครไม่พบ กรุณาตรวจสอบและกรอกใหม่"
    },
    "userDialog": {
      "id": "รหัสตัวละคร",
      "name": "ชื่อตัวละคร",
      "confirmText": "กรุณายืนยันข้อมูลตัวละคร",
      "confirmInput": "ยืนยัน",
      "cancelInput": "กรอกใหม่"
    },
    "payStatusDialog": {
      "cancelText": "ยกเลิก",
      "paySuccess": "การเติมเงินเสร็จสิ้น!",
      "payFailed": "การเติมเงินล้มเหลว",
      "paying": "กำลังค้นหา..."
    },
    "mallGuideDialog": {
      "title": "เติมเงินสำเร็จ",
      "desc": "การเติมเพชรสายรุ้งของคุณเสร็จสมบูรณ์แล้ว ไปที่ร้านค้าสมาชิกตอนนี้เพื่อรับรางวัลของคุณ!",
      "claimLater": "รับภายหลัง",
      "goNow": "ไปตอนนี้"
    },
    "paymentMethod": {
      "title": "เลือกวิธีการชำระเงิน",
      "recommend": "แนะนำ",
      "moreMethod": "วิธีการชำระเงินอื่นๆ",
      "confirm": "ยืนยัน",
      "diankaTip1": "",
      "diankaTip2": ""
    },
    "product": {
      "title": "เลือกแพ็คเกจการเติมเงิน",
      "gift-single": "โบนัส",
      "gift": "โบนัส",
      "giftRegular": "โบนัสปกติ",
      "giftActivity": "เติมครั้งแรกรับเพิ่ม",
      "giftActivityBadge": "เติมครั้งแรกรับเพิ่ม {num}",
      "giftRegularBadge": "+{num} เพชรรุ้ง",
      "giftPointsBadge": "+{num} คะแนน",
      "coinTotal": "รวม {total} ({coin}+{gift})",
      "coinTotalOnly": "รวม {total}",
      "remaining": "เหลืออีก {num} ครั้ง",
      "points": "คะแนน",
      "summary": "ข้อมูลสรุป",
      "selected": "แพ็คเกจที่เลือก",
      "diamond": "เพชรสีรุ้ง",
      "total": "ราคารวม",
      "confirm": "ยืนยัน",
      "limit": "ขีดจำกัดการซื้อ"
    }
  },
  "header": {
    "memberStore": "ร้านค้าสมาชิก"
  },
  "tabbar": {
    "recharge": "เติมเงิน",
    "pointsMall": "ร้านค้าแต้ม"
  },
  "footer": {
    "link": {
      "privacy": "ข้อกำหนดของผู้ใช้",
      "security": "นโยบายความเป็นส่วนตัว"
    },
    "jumpLink": {
      "fb": "https://www.facebook.com/profile.php?id=61576343595987",
      "fbGroup": "https://www.facebook.com/groups/miniworldroyale.th",
      "dc": "https://discord.gg/Eqje65WBpf",
      "yt": "https://www.youtube.com/{'@'}miniworldroyale.thailand",
      "tt": "https://www.tiktok.com/{'@'}miniworldroyale.th",
      "privacy": "https://www.miniworldroyale.com/terms/19",
      "security": "https://www.miniworldroyale.com/terms/20"
    },
    "text": "หากคุณพบปัญหาระหว่างการชำระเงิน โปรดส่งอีเมลไปที่ ministarcustomerservice{'@'}gmail.com เพื่อขอความช่วยเหลือ"
  },
  "customerServiceText": "กรุณาติดต่อเราทางอีเมลที่ ministarcustomerservice{'@'}gmail.com",
  "cancelText": "กลับไปที่การเติมเงิน",
  "api": {
    "networkError": "ข้อผิดพลาดของเครือข่าย",
    "serverError": "ข้อผิดพลาดของเซิร์ฟเวอร์, รหัสข้อผิดพลาด:"
  },
  "poolParty": {
    "box1": "หีบสมบัติแรร์",
    "box2": "หีบสมบัติหรู",
    "loginDialog": {
      "title": "ยืนยันตัวละครแล้วรับของขวัญต้อนรับ"
    },
    "prop": {
      "ACTIVITY_SWIM_RING": "ห่วงยาง",
      "ACTIVITY_WATER_GUN": "ปืนฉีดน้ำ",
      "ACTIVITY_SUN_UMBRELLA": "ร่มชายหาด",
      "ACTIVITY_SWIM_GOGGLES": "แว่นตาว่ายน้ำ",
      "80202003": "บัตรอัปเกรดอาวุธระดับ 3",
      "70100101": "เพชรทอง",
      "80102101": "ตั๋วจับรางวัล เพชรทอง",
      "80102004": "คูปองส่วนลด",
      "80103001": "บัตรป้องกันอันดับ",
      "80103002": "บัตรเพิ่มคะแนนอันดับสองเท่า",
      "70100011": "เหรียญทอง",
      "70100014": "กุญแจสมบัติลับ",
      "70100013": "คูปองสมบัติลับ",
      "81010999": "เหรียญเติบโตครอบจักรวาล",
      "90301907": "[พิเศษ] กรอบรูปโปรไฟล์ – ปาร์ตี้ริมสระน้ำ"
    },
    "record": {
      "title": "ประวัติรางวัล",
      "detailTitle": "รายละเอียดรางวัล",
      "dateTitle": "เวลาการรับรางวัล",
      "noData": "ไม่มีข้อมูล"
    },
    "btnCanReceive": "มีอยู่",
    "btnReceived": "ได้รับแล้ว",
    "btnNotReach": "ยังไม่ได้รับ",
    "goRecharge": "ไปที่หน้าเติมเงิน",
    "welcomeReward": {
      "title": "ของขวัญต้อนรับ",
      "desc": "รับทันทีหลังยืนยันตัวละคร"
    },
    "exchange": {
      "desc1": "สะสมไอเทมปาร์ตี้ริมสระน้ำทั้งหมดเพื่อรับกรอบรูปสุดพิเศษ—ปาร์ตี้ริมสระน้ำ—ฟรี",
      "desc2": "ในระหว่างกิจกรรม เมื่อเติมเพชรสีรุ้งสะสมครบ 1,000, 2,000 หรือ 3,000 เม็ด คุณสามารถรับไอเทมปาร์ตี้ริมสระที่คุณยังไม่มีได้",
      "mainPropName": "[พิเศษ] กรอบรูปโปรไฟล์ – ปาร์ตี้ริมสระน้ำ"
    },
    "dailyReward": {
      "day": "วันที่ {day}",
      "desc": "รับหีบสมบัติหลังซื้อเพชรรุ้งครั้งแรกในแต่ละวัน"
    },
    "accumReward": {
      "itemTitle": "รางวัลปาร์ตี้ริมสระน้ำ",
      "itemCountText": "สะสมยอดเติมเพชรรุ้งถึง {need} เม็ด ({current}/{need})",
      "randomProp": "สุ่มไอเทมปาร์ตี้",
      "randomPropNotOwned": "สุ่มไอเทมปาร์ตี้ (ที่ยังไม่มี)"
    },
    "rule": {
      "item1": "ในช่วงเวลากิจกรรม หลังจากเติมเงินเพชรรุ้ง ครั้งแรกในแต่ละวัน คุณสามารถรับกล่องแรร์ได้ 1 กล่อง แต่ละกล่องแรร์จะมีไอเทมในเกมและไอเทมปาร์ตี้ริมสระ 1 ชิ้น",
      "item2": "มีไอเทม ปาร์ตี้ริมสระ ทั้งหมดมี 4 แบบ ได้แก่ ห่วงยาง, ปืนฉีดน้ำ, ร่มชายหาด, และแว่นตาว่ายน้ำ ไอเทมเหล่านี้สามารถใช้ได้เฉพาะในหน้านี้เท่านั้น สะสมไอเทมทั้ง 4 ให้ครบเพื่อรับรางวัลสุดพิเศษ: [พิเศษ] กรอบรูปอวาตาร์ – ปาร์ตี้ริมสระ",
      "item3": "กล่องที่ 3 และ 7 เป็นกล่องดีลักซ์ ซึ่งมีไอเทมในเกมเพิ่มเติมและรับประกันว่าจะได้รับไอเทม ปาร์ตี้ริมสระที่คุณยังไม่มี",
      "item4": "ใในช่วงระยะเวลาของกิจกรรม เมื่อยอดเติมเงิน เพชรรุ้ง สะสมถึง 1,000 / 2,000 / 3,000 คุณสามารถปลดล็อกแพ็คปาร์ตี้ริมสระเพิ่มเติมได้ แต่ละแพ็คปาร์ตี้ริมสระ รับประกันว่าจะได้รับไอเทมที่คุณยังไม่มี",
      "item5": "ผู้จัดงานขอสงวนสิทธิ์ในการตีความขั้นสุดท้ายของกิจกรรม",
      "item6": ""
    }
  },
  "accumRecharge": {
    "countDownTitle": "นับถอยหลังสู่การเริ่มกิจกรรม",
    "countFuhao": "*",
    "clickHere": "คลิกที่นี่",
    "introduce": "ไปที่หน้าชำระเงินออนไลน์ [clickHere] เติม 500/1000/2500/5000/10000 เพชร เพื่อรับรางวัลหลายแบบ\nเวลากิจกรรม: 18/9/2025 23:00 - 06/10/2025 22:59 (เวลาไทย)\nเวลาการรับรางวัลจะสิ้นสุดในวันที่ 12/10/2025 22:59 (เวลาไทย)",
    "goRecharge": "ไปที่หน้าเติมเงิน",
    "rewards": {
      "goRecharge": "ไปที่หน้าเติมเงิน",
      "record": "ประวัติรางวัล",
      "rewardsAll": "รับรางวัลในคลิ๊กเดียว",
      "rewardTimes": "จำนวนการรับ:",
      "btnStatus": {
        "canReceive": "สามารถรับได้",
        "received": "รับแล้ว",
        "goRecharge": "ไปที่หน้าเติมเงิน"
      },
      "recordTable": {
        "name": "ระดับการเติมเงิน",
        "details": "รายละเอียดรางวัล",
        "time": "เวลาการรับรางวัล"
      }
    },
    "rule": {
      "title": "รายละเอียด:",
      "content": "วิธีการเติมเงิน: คลิกปุ่ม  [goRecharge]ด้านบนเพื่อไปยังหน้าชำระเงินออนไลน์ โปรดเลือกการเติมเงินที่ต้องการเพื่อเข้าร่วม!\nวิธีการรับรางวัล: หลังจากเติมเงินแล้ว คลิกที่ปุ่มรับรางวัลด้านบนเพื่อรับรางวัลโดยอัตโนมัติภายในเกม หรือรับรางวัลผ่านกล่องข้อความในเกม\nจำนวนรางวัล: แต่ละระดับการเติมเงินจะมีจำนวนครั้งการรับรางวัลจำกัด การเติมเงินหลังจำนวนที่กำหนดจะไม่สามารถรับรางวัลได้"
    },
    "rewardsAllDialog": {
      "content": "การรับรางวัลสำเร็จในคลิกเดียว!\nคุณสามารถไปที่ 【ประวัติรางวัล】 เพื่อตรวจสอบรายละเอียดรางวัล"
    },
    "rewardsTimes": {
      "times": "จำนวนครั้ง"
    }
  },
  "accum": {
    "actStartCountDown": "นับถอยหลังการเริ่มกิจกรรม",
    "actEndCountDown": "นับถอยหลังสิ้นสุดกิจกรรม",
    "rewardEndCountDown": "นับถอยหลังการรับรางวัล",
    "actEnded": "กิจกรรมสิ้นสุดแล้ว",
    "clickHere": "คลิกที่นี่",
    "goRecharge": "ไปที่หน้าเติมเงิน",
    "record": "ประวัติรางวัล",
    "rewardsAll": "รับรางวัลในคลิ๊กเดียว",
    "rewards": {
      "eventDesc": "ใช้ช่องทางเติมเงินอย่างเป็นทางการ [{clickHere}] เติม [เพชรรุ้ง] 100/300/500/1000/2000/3000/5000/10000 คุณสามารถรับรางวัลได้!(นับเฉพาะ [เพชรรุ้ง] พื้นฐานเท่านั้น ไม่รวมโบนัส [เพชรรุ้ง])",
      "eventDescDuojin": "รางวัลกิจกรรมอัปเกรดแล้ว! เพิ่มรางวัลพิเศษสำหรับโหมดใหม่ล่าสุด {duojin} มาให้แล้ว อย่าพลาด เข้าร่วมและรับรางวัลได้เลย!",
      "duojin": "[โหมดล่าสมบัติ]",
      "eventTime": "เวลากิจกรรม: 12 มิถุนายน 2026 (00:00) - 21 มิถุนายน 2026 (23:59) (GMT+7)",
      "rewardEndTime": "เวลาการรับรางวัลจะสิ้นสุดในวันที่ 28 มิถุนายน 2026 (23:59) (GMT+7)",
      "diffDiamond": "เติม Rainbow Diamonds [diamondNum] เพิ่มเพื่อรับรางวัลครั้งต่อไปของคุณ",
      "btnCanReceive": "มีอยู่",
      "btnReceived": "ได้รับแล้ว",
      "btnNotReach": "ยังไม่ได้รับ",
      "canReceiveAll": "คุณสามารถรับรางวัลทั้งหมดได้"
    },
    "rewardsAllDialog": {
      "title": "ยินดีด้วย คุณได้รับรางวัล",
      "content": "การรับรางวัลสำเร็จในคลิกเดียว! คุณสามารถไปที่ [record] เพื่อตรวจสอบรายละเอียดรางวัล"
    },
    "recordDialog": {
      "title": "ประวัติรางวัล",
      "reachNode": "บันทึกการเติม",
      "details": "รายละเอียดรางวัล",
      "time": "เวลาการรับรางวัล",
      "noData": "ไม่มีข้อมูล"
    },
    "rule": {
      "content": "1. วิธีเติมเงิน:\nคลิกปุ่ม {goRecharge} ด้านบนเพื่อเข้าสู่แพลตฟอร์มเติมเงินอย่างเป็นทางการและซื้อเพชรสายรุ้ง!\n\n2. วิธีรับรางวัล:\nเติมเงินตามที่กำหนดและกด \"รับรางวัล\" รางวัลจะถูกส่งไปยังกล่องจดหมายในเกมของคุณ อย่าลืมล็อกอินเข้าเกมและรับรางวัล!\n\n3. ข้อจำกัดของรางวัล:\nรางวัลเติมเงินสะสมแต่ละรางวัลสามารถรับรางวัลได้เพียงครั้งเดียวเท่านั้น และไม่สามารถรับซ้ำได้\n\n4. ข้อจำกัดความรับผิดชอบ:\nเนื้อหากิจกรรมทั้งหมดขึ้นอยู่กับการแสดงผลจริงในหน้ากิจกรรม สิทธิ์ในการตีความขั้นสุดท้ายของกิจกรรมนี้เป็นของทีมงานอย่างเป็นทางการ"
    }
  },
  "cny": {
    "goRecharge": "ไปที่หน้าเติมเงิน",
    "record": "ประวัติรางวัล",
    "remainingTimes": "จำนวนครั้งที่เหลือในการสุ่ม",
    "skipAnimation": "ข้ามแอนิเมชันสุ่ม",
    "lotteryOnce": "สุ่ม 1 ครั้ง",
    "lotteryOneKey": "คลิกเดียวสุ่ม",
    "lottery": {
      "desc": "ใช้แพลตฟอร์มเติมเงินอย่างเป็นทางการ ทุกๆ 500 Rainbow Diamonds ที่เติมเงิน จะทำให้ได้รับสิทธิ์หมุนวงล้อ Lucky Wheel หนึ่งครั้ง\n(หมายเหตุ: นับเฉพาะจำนวนพื้นฐานของ Colored Diamonds ที่เติมเงินเท่านั้น ไม่รวมโบนัส Colored Diamonds)",
      "times": "ระยะเวลาสะสมแต้ม: 24 ธันวาคม 2568 เวลา 00:01 น. - 12 มกราคม 2569 เวลา 23:59 น. (GMT+7)\nระยะเวลารับรางวัล: 24 ธันวาคม 2568 เวลา 00:01 น. - 18 มกราคม 2569 เวลา 23:59 น. (GMT+7)"
    },
    "lotteryRewardDialog": {
      "title": "ยินดีด้วย คุณได้รับรางวัล"
    },
    "rewards": {
      "desc": "สะสม 2, 5, 10, 20, 30 และ 50 การสุ่มบนเพจกิจกรรมนี้เพื่อรับหีบความคืบหน้าเพิ่มเติม",
      "times": "ระยะเวลาสะสมแต้ม: 22 ธันวาคม 2568 เวลา 00:00 น. - 12 มกราคม 2569 เวลา 00:59 น. (GMT+7)\nระยะเวลารับรางวัล: 22 ธันวาคม 2568 เวลา 00:00 น. - 18 มกราคม 2569 เวลา 23:59 น. (GMT+7)",
      "lotteryNTimes": "สุ่ม {times} ครั้ง",
      "reachNode": "ระดับรางวัล",
      "rewardsAllDialog": {
        "content": "การรับรางวัลสำเร็จในคลิกเดียว!\nคุณสามารถไปที่ 【ประวัติรางวัล】 เพื่อตรวจสอบรายละเอียดรางวัล"
      }
    },
    "rule": {
      "content": "1. ในช่วงกิจกรรม ทุกๆ 500 Rainbow Diamonds ที่เติมเงินบนแพลตฟอร์มเติมเงินอย่างเป็นทางการ คุณจะได้รับการหมุนวงล้อนำโชคหนึ่งครั้ง (หมายเหตุ: นับเฉพาะยอดเติมเงินพื้นฐานเท่านั้น ไม่รวมโบนัสเพชรสี)\n2. การสะสมการสุ่ม 2, 5, 10, 20, 30 และ 50 ครั้งในหน้ากิจกรรมนี้ จะทำให้คุณได้รับรางวัลหีบสมบัติความคืบหน้าเพิ่มเติม\n3.ระยะเวลาสะสมแต้ม: 24 ธันวาคม 2568 เวลา 00:01 น. - 12 มกราคม 2569 เวลา 23:59 น. (GMT+7)\tระยะเวลารับรางวัล: 24 ธันวาคม 2568 เวลา 00:01 น. - 18 มกราคม 2569 เวลา 23:59 น. (GMT+7)\n4.ทีมงานขอสงวนสิทธิ์ในการตีความกิจกรรมนี้อย่างเป็นที่สุด"
    }
  },
  "mwr": {
    "actTimeDialogText": "กิจกรรมจะเปิดตัวอย่างเป็นทางการในวันที่ 13 กุมภาพันธ์",
    "actTimeDialogText2": "เวลา 00:00 (GMT +7) น. โปรดติดตาม!",
    "save": "บันทึก",
    "share": "แชร์",
    "mission": {
      "receiveRewardSuccess": "รับรางวัลสำเร็จ",
      "header": "ภารกิจ",
      "progress": "ความคืบหน้า",
      "btns": {
        "canReceive": "รับรางวัล",
        "received": "สำเร็จ",
        "notReach": "ยังไม่สำเร็จ",
        "shareImmediate": "แชร์เลย"
      },
      "list": {
        "1": {
          "key": "dailyLogin",
          "title": "รับรางวัลฟรีทุกวันจากการล็อกอิน",
          "desc": "รายวัน"
        },
        "2": {
          "key": "loginDaysGt3",
          "title": "ล็อกอินสะสมครบ 3 วัน",
          "desc": "ภารกิจครั้งเดียว"
        },
        "3": {
          "key": "loginDaysGt7",
          "title": "ล็อกอินสะสมครบ 7 วัน",
          "desc": "ภารกิจครั้งเดียว"
        },
        "4": {
          "key": "shareMwr",
          "title": "แชร์ฉายา/สรุปผลงานลงโซเชียลมีเดีย",
          "desc": "ภารกิจครั้งเดียว"
        },
        "5": {
          "key": "playedFiveNewMode",
          "title": "เล่นโหมดที่แตกต่างกัน 3 โหมด",
          "desc": "รายวัน"
        },
        "6": {
          "key": "playedFiveNewMode",
          "title": "เล่นโหมดใหม่ครบ 5 ครั้ง",
          "desc": "ภารกิจครั้งเดียว"
        }
      }
    },
    "turn": "จำนวนการโจมตี",
    "turnNum": "จำนวนการโจมตี+{num} รอบ",
    "logout": "ออกจากระบบ",
    "home": {
      "statsPage": {
        "text": "สรุปภาพรวม\nMWR\n2025",
        "btnText": "ดูรายละเอียด"
      },
      "dragonPage": {
        "text": "พิชิตมังกร",
        "btnText": "ไปกันเลย"
      }
    },
    "dragon": {
      "noTurn": "จำนวนการโจมตีหมดแล้ว",
      "serverProgress": "ความคืบหน้ารวมของเซิร์ฟเวอร์",
      "treasureBox": {
        "notReach": "ยังไม่สำเร็จ",
        "received": "สำเร็จ"
      },
      "rule": "ผู้เล่นทั้งเซิร์ฟเวอร์ต้องร่วมแรงร่วมใจกันเพื่อพิชิตมังกรปีศาจ เมื่อความเสียหายสะสมที่คุณทำได้ถึงเกณฑ์ที่กำหนด คุณจะสามารถรับรางวัลจากหีบสมบัติได้\n1. การโจมตีมังกรแต่ละครั้งจะใช้ สิทธิ์การโจมตี 1 ครั้ง\n2. สิทธิ์การโจมตีสามารถรับได้จากการทำภารกิจให้สำเร็จ\n3. เมื่อความเสียหายสะสมที่ทำต่อมังกรถึง 4052, 10130 และ 20260\n4. หีบรางวัลตามลำดับขั้นจะถูกปลดล็อกเพื่อให้ผู้เล่นเข้ามารับรางวัล ในการเปิดหีบแต่ละครั้งมีโอกาสได้รับ หีบแรร์ระดับอัลตร้า โดยของรางวัลจากหีบระดับอัลตร้านี้จะเข้ามาแทนที่ของรางวัลในหีบปกติ\n5. อัตราการดรอปของหีบแรร์ระดับอัลตร้าคือ 0.001% และของรางวัลคือ 19,999 เพชรทองคำ\n6. เมื่อมังกรปีศาจถูกกำจัด ผู้เล่นทุกคนจะได้รับรางวัลผ่านทางระบบจดหมาย\n\nถาม/ตอบ\n1. กิจกรรมนี้เริ่มเมื่อไหร่?\nตอบ: ระยะเวลากิจกรรม: 9 กุมภาพันธ์ เวลา 00:00 น. – 1 มีนาคม เวลา 23:59 น. (GMT+7)\n\n2. ของรางวัลจะถูกส่งมอบอย่างไร?\nตอบ: ของรางวัลทั้งหมดในช่วงกิจกรรมจะถูกส่งผ่านทางจดหมายภายในเกม โปรดตรวจสอบที่กล่องจดหมายของคุณ\n\n3. บันทึกภาพสกรีนช็อตของหน้า สรุปภาพรวม MWR 2025 อย่างไร?\nตอบ: ที่มุมขวาล่างของหน้าสรุปผล จะมีตัวเลือก \"บันทึก\" (Save) เมื่อคลิกแล้วระบบจะสร้างภาพสกรีนช็อตให้โดยอัตโนมัติ จากนั้นให้ผู้เล่น กดค้างที่รูปภาพ เพื่อบันทึกรูปลงในแกลเลอรีของโทรศัพท์\n\n4. หากมังกรถูกกำจัดไปแล้ว ฉันยังจะเข้าร่วมกิจกรรมได้อยู่ไหม?\nตอบ: หากมังกรถูกปราบแล้ว ผู้เล่นจะไม่สามารถเข้าร่วมกิจกรรมหรือรับหีบสมบัติได้อีก~ ดังนั้น อย่าลืมมาร่วมสนุกให้ตรงเวลา\n\n5. รับรางวัลหลายครั้งได้ไหม\nตอบ: รางวัลแต่ละขั้นสามารถรับได้เพียงครั้งเดียวเท่านั้น การเติมเงินซ้ำจะไม่ได้รับรางวัลเดียวกัน\n\n6. ทำไมฉันทำภารกิจรายวันสำเร็จแล้ว\nตอบ: แต่จำนวนครั้งในการโจมตีถึงไม่เพิ่มขึ้น?\nหลังจากทำภารกิจสำเร็จ ระบบจะต้องใช้เวลาประมาณ 30 วินาที ในการตรวจสอบและอัปเดตสถานะ\n\n7. จะเกิดอะไรขึ้นถ้าฉันกดรับรางวัลไม่ทันเวลา?\nตอบ: โปรดตรวจสอบให้แน่ใจว่าได้กดรับรางวัลทั้งหมดก่อนวันที่ 1 มีนาคม เวลา 23:59 น. (GMT+7) รางวัลที่ไม่ได้กดรับภายในเวลาที่กำหนดจะถือว่าสละสิทธิ์ และไม่สามารถขอรับย้อนหลังได้\n\n8. ฉันจะติดต่อฝ่ายบริการลูกค้าได้อย่างไร?\nตอบ: โปรดส่งอีเมลไปที่ ministarcustomerservice{'@'}gmail.com โดยระบุ ID ผู้เล่น และ เวลาที่กดรับรางวัล ทีมงานของเราจะรีบเข้าไปช่วยเหลือคุณโดยเร็วที่สุด",
      "boxRecord": {
        "title": "ประวัติการรับรางวัล",
        "box": "กล่อง",
        "reward": "ของรางวัล",
        "time": "วันที่ได้รับ",
        "box1Name": "กล่องขั้นที่ I",
        "box2Name": "กล่องขั้นที่ II",
        "box3Name": "กล่องขั้นที่ III"
      },
      "superBox": {
        "text1": "มังกรปีศาจถูกสยบแล้ว!",
        "text2": "รางวัลพิเศษสำหรับผู้เล่นทั้งเซิร์ฟเวอร์ถูกส่งไปยังจดหมายในเกมของคุณเรียบร้อยแล้ว รีบเข้าเกมไปกดรับกันได้เลย!",
        "text3": "ขอให้มีความสุขในเทศกาลปีใหม่นะ เหล่านักแม่นปืน!"
      }
    },
    "stats": {
      "infos": {
        "page-1-left-title": "การเดินทางของคุณในปี 2025",
        "page-1-left-desc": "เรียน ยอดนักแม่นปืน",
        "page-1-right-title": "การเดินทางอันยิ่งใหญ่ของคุณตลอดปี 2025",
        "page-2-left-title": "ไฮไลต์การต่อสู้",
        "page-2-right-title": "ไฮไลต์ของสะสม",
        "totalGameTime": "เวลาเล่นทั้งหมด",
        "totalKillCount": "จำนวนสังหารทั้งหมด",
        "alwaysPlayMode": "โหมดที่เล่นบ่อยที่สุด ",
        "maxRankScore": "แรงก์สูงสุดที่ทำได้",
        "maxWeaponId": "อาวุธที่ใช้บ่อยที่สุด",
        "maxLongWinningCount": "สถิติชนะต่อเนื่องนานที่สุด",
        "maxLongLoginDays": "สถิติการล็อกอินต่อเนื่องนานที่สุด",
        "topFriendId": "เพื่อนร่วมทีมที่สนิทที่สุด",
        "totalWeaponCount": "จำนวนอาวุธและปืนทั้งหมดที่มีครอบครอง",
        "totalAvtCount": "จำนวนสกินและอุปกรณ์ DIY ทั้งหมดที่มีครอบครอง",
        "modeType-1": "โหมด ดวลปืน",
        "modeType-2": "โหมด โดดร่ม",
        "modeType-3": "โหมด คนป่า",
        "hour": "ชั่วโมง",
        "day": "วัน"
      },
      "chenghao": {
        "isForty": "ผู้ท้าชิงมฤตยู",
        "isTwenty": "จอมสังหารระดับอีลิท",
        "isGame100": "จุดสูงสุดระดับโลก",
        "modeID-1": "ดวลปืน - นักวางแผนกลยุทธ์",
        "modeID-2": "โดดร่ม - ผู้เหนือกว่าคนสุดท้าย",
        "modeID-3": "คนป่า - ผู้ทำลายล้างคนป่า",
        "weaponType-1": "SCAR - ผู้บัญชาการสมรภูมิ",
        "weaponType-2": "DMR - ผู้คุมกฎความแม่นยำ",
        "weaponType-3": "SR - เพชฌฆาตไร้เสียง",
        "weaponType-4": "Light MG - ขุนศึกจอมกดดัน",
        "weaponType-5": "SMG - ยมทูตแห่งเงา",
        "weaponType-6": "Shotgun - ผู้ทำลายล้างระยะประชิด",
        "weaponType-7": "Heavy MG - ปราการเหล็ก",
        "weaponType-8": "อาวุธประชิด - หัตถ์พระเจ้า",
        "is10WValue": "ผู้นำแฟชั่น",
        "is15WValue": "จ้าวแห่งเทรนด์",
        "is20WValue": "ไอคอนระดับตำนาน"
      },
      "chenghaoDesc": {
        "isForty": "ติดอันดับผู้เล่น Top 40% ที่มีอัตราการกำจัดศัตรูสูงสุด",
        "isTwenty": "ติดอันดับผู้เล่น Top 20% ที่มีอัตราการกำจัดศัตรูสูงสุด",
        "isGame100": "ติดอันดับ Top 100 จากทุกโหมดการเล่น",
        "modeID-1": "โหมดที่เล่นบ่อยที่สุด",
        "modeID-2": "โหมดที่เล่นบ่อยที่สุด",
        "modeID-3": "โหมดที่เล่นบ่อยที่สุด",
        "weaponType-1": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-2": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-3": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-4": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-5": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-6": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-7": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "weaponType-8": "ประเภทปืนที่ใช้บ่อยที่สุด",
        "is10WValue": "คะแนนแฟชั่นมากกว่า 100,000",
        "is15WValue": "คะแนนแฟชั่นมากกว่า 150,000",
        "is20WValue": "คะแนนแฟชั่นมากกว่า 200,000"
      }
    }
  },
  "sf": {
    "endCountdown": "นับถอยหลังจบกิจกรรม",
    "startCountdown": "นับถอยหลังเริ่มกิจกรรม",
    "ended": "กิจกรรมสิ้นสุดลงแล้ว โปรดกดรับรางวัลของท่านภายในเวลาที่กำหนด",
    "notStart": "กิจกรรมยังไม่เริ่ม",
    "day": "วัน",
    "lottery": {
      "desc": "ในช่วงระยะเวลากิจกรรม\n1. ทุกการเติมเงิน 100 เพชรรุ้ง ผ่านทาง [เว็บไซต์เติมเงินอย่างเป็นทางการ] รับฟรีทันที! ไอเทม [พลุดอกไม้ไฟ] 1 ชิ้น\n2. ทุกครั้งที่จุด [พลุดอกไม้ไฟ] คุณจะได้รับรางวัลแบบสุ่ม และเมื่อสะสมจำนวนการจุดพลุได้ครบตามที่กำหนด จะสามารถปลดล็อก \"หีบรางวัลใหญ่\" ตามระดับขั้นได้อีกด้วย!\n3. หมายเหตุ: ระบบจะนับเฉพาะจำนวน เพชรรุ้ง หลักจากการเติมเงินเท่านั้น (ไม่รวมเพชรโบนัสแถมฟรี) โปรดตรวจสอบยอดการเติมเงินของคุณก่อนเข้าร่วม",
      "times": "ระยะเวลาสะสมยอดเติมเงิน: 9 กุมภาพันธ์ (00:00 น.) – 1 มีนาคม (23:59 น.)\nระยะเวลากดรับของรางวัล: 9 กุมภาพันธ์ (00:00 น.) – 9 มีนาคม (23:59 น.)",
      "remainingTimes": "สิทธิ์ที่เหลือ",
      "skipAnimation": "ข้ามแอนิเมชัน"
    },
    "lotteryOnce": "จุดพลุ 1 ครั้ง",
    "lotteryOneKey": "จุดพลุทั้งหมด",
    "rewards": {
      "canReceiveAll": "คุณสามารถรับรางวัลทั้งหมดได้",
      "diffDiamond": "ต้องการอีก [diamondNum] [พลุ] เพื่อรับรางวัลถัดไป",
      "lotteryNTimes": "{times}ครั้ง"
    },
    "rule": {
      "content": "ในช่วงระยะเวลากิจกรรม\n1. ทุกการเติมเงิน 100 เพชรรุ้ง ผ่านทาง [เว็บไซต์เติมเงินอย่างเป็นทางการ] รับฟรีทันที! ไอเทม [พลุดอกไม้ไฟ] 1 ชิ้น\n2. ทุกครั้งที่จุด [พลุดอกไม้ไฟ] คุณจะได้รับรางวัลแบบสุ่ม และเมื่อสะสมจำนวนการจุดพลุได้ครบตามที่กำหนด จะสามารถปลดล็อก \"หีบรางวัลใหญ่\" ตามระดับขั้นได้อีกด้วย!\n3. หมายเหตุ: ระบบจะนับเฉพาะจำนวน เพชรรุ้ง หลักจากการเติมเงินเท่านั้น (ไม่รวมเพชรโบนัสแถมฟรี) โปรดตรวจสอบยอดการเติมเงินของคุณก่อนเข้าร่วม"
    }
  },
  "wc2026": {
    "login": {
      "logintxt": "ล็อกอิน",
      "inputCode": "กรุณากรอกรหัสยืนยัน",
      "sendCode": "รหัสยืนยันถูกส่งยังเมลในเกม",
      "submit": "ยืนยัน",
      "cancel": "ยกเลิก",
      "codeSent": "ส่งรหัสยืนยันแล้ว โปรดตรวจสอบกล่องจดหมายในเกม",
      "loginSuccess": "เข้าสู่ระบบสำเร็จ",
      "codeError": "เข้าสู่ระบบล้มเหลว",
      "emailPlaceholder": "กรุณากรอกบัญชี",
      "codePlaceholder": "กรุณากรอกรหัสยืนยัน"
    },
    "logout": "[ออกจากระบบ]",
    "intro": {
      "title": "คำแนะนำกิจกรรม",
      "contentText": "เชียร์บอลโลก — เลือกทีมที่คุณรักแล้วรับรางวัลแบบล้น ๆ!\r\nทำภารกิจประจำวันเพื่อรับ “โอกาสในการเชียร์” จากนั้นไปเชียร์ทีมที่คุณชื่นชอบบนหน้าตารางการแข่งขัน ฟุตบอลโลกครั้งนี้มีทั้งหมด 48 ทีม แข่งขันตลอดระยะเวลา 39 วัน\r\nยิ่งคุณเชียร์การแข่งขันมากเท่าไหร่ ก็ยิ่งปลดล็อกรางวัล รางวัลสะสม และรางวัลจาก ลีดเดอร์บอร์ด ได้มากขึ้นเท่านั้น"
    },
    "tabs": {
      "rewardHistory": "ประวัติการรับรางวัล",
      "cheerCountLabel": "จำนวนโอกาสเชียร์ของฉัน:",
      "goEarn": "ไปทำภารกิจ",
      "cheerPowCash": "สงครามพลังเชียร์",
      "toCheer": "เชียร์ทีม"
    },
    "rank": {
      "title": "อันดับสุดยอดสายเชียร์",
      "rank": "อันดับ",
      "nickname": "ชื่อในเกม",
      "winCount": "เชียร์สำเร็จ",
      "awardDes": "แนะนำเกี่ยวกับรางวัล เช่น ผู้เล่น 50 อันดับแรกในอันดับการทายผลถูกต้อง สามารถรับรางวัลได้",
      "des2": "อันดับ 4–10: 700 เพชรทอง , อันดับ 11–25: 400 เพชรทอง , อันดับ 26–50: 200 เพชรทอง",
      "des1": "อันดับ 1: 2,000 เพชรทอง , อันดับ 2: 1,500 เพชรทอง , อันดับ 3: 1,000 เพชรทอง"
    },
    "accountId": "ID",
    "noData": "ยังไม่มีข้อมูล",
    "reaawardName": "ชื่อรางวัล",
    "cheerTime": "จำนวนครั้งที่เชียร์สำเร็จ",
    "times": "ครั้ง",
    "bet": {
      "matchResult": {
        "pending": "การแข่งขันยังไม่เริ่ม",
        "cheered": "เชียร์",
        "draw": "ยกเลิกการแข่งขัน",
        "win": "_team ชนะ",
        "daping": "เสมอ",
        "running": "การแข่งขันกำลังดำเนินการ"
      },
      "selectDate": "ตารางการแข่งขัน",
      "noMatches": "ไม่มีการแข่งขัน",
      "cheerSuccess": "เชียร์สำเร็จ",
      "confirm": {
        "content": "ยืนยันการเชียร์"
      }
    },
    "backTop": "กลับไปด้านบน",
    "milestone,mainTitle": "เชียร์เพื่อรับรางวัล",
    "milestone": {
      "totalCheer": "รางวัลสะสมการเชียร์",
      "winCheer": "รางวัลความสำเร็จสะสม",
      "subTitleTotal": "ยิ่งคุณเชียร์การแข่งขันมากเท่าไหร่ รางวัลก็จะยิ่งมากขึ้นเท่านั้น!",
      "subTitleWin": "ยิ่งคุณทำคะแนนเชียร์ได้สำเร็จมากเท่าไหร่ รางวัลก็จะยิ่งมากขึ้นเท่านั้น!",
      "betTarget": "_n ครั้ง",
      "title1": "เชียร์_n_ครั้ง",
      "title2": "เชียร์สำเร็จ_n_ครั้ง"
    },
    "betTarget": "5 ครั้ง",
    "received": "รับแล้ว",
    "canReceive": "สามารถรับได้",
    "notReach": "ยังไม่สำเร็จ",
    "rule": {
      "title": "รายละเอียดกฎการเชียร์",
      "content": "1. วิธีการเชียร์\r\nในแต่ละการแข่งขัน จะมีการแสดงธงและชื่อของทั้งสองทีม ผู้เล่นสามารถเลือกเชียร์ได้ 1 ทีมต่อการแข่งขัน ผู้เล่นแต่ละคนสามารถเชียร์ได้เพียงครั้งเดียวต่อแมตช์ และจำนวน โอกาสในการเชียร์ จะถูกหักทันทีหลังจากส่งการเชียร์ — ไม่สามารถยกเลิกหรือแก้ไขได้หลังจากส่งแล้ว\r\nการเชียร์จะเปิดให้เข้าร่วมล่วงหน้าสูงสุด 2 วันก่อนการแข่งขันเริ่ม และจะปิดทันทีเมื่อการแข่งขันเริ่มต้น\r\nในรอบน็อกเอาต์ จะใช้กติกาเดียวกับรอบแบ่งกลุ่ม: ผู้เล่นเลือกเชียร์ได้ 1 ทีม และจะไม่มีตัวเลือก “เสมอ” ในรอบน็อกเอาต์\r\n\r\n2. การตัดสินผลและรางวัล\r\nหากทีมที่คุณเชียร์ชนะ การเชียร์ของคุณจะถือว่าสำเร็จ และคุณจะได้รับรางวัลไอเทมภายในเกม \r\nหากการแข่งขันจบลงด้วยผลเสมอ (เฉพาะรอบแบ่งกลุ่ม) ผู้เล่นที่เชียร์ทีมใดทีมหนึ่งจะได้รับรางวัลทั้งหมด \r\nผลการเชียร์จะอ้างอิงจากผลการแข่งขันอย่างเป็นทางการสุดท้าย \r\nเมื่อทำถึงเป้าหมายการเชียร์สะสม จะปลดล็อกรางวัลตามเป้าหมายนั้น และจำนวนการเชียร์ที่สำเร็จทั้งหมดจะถูกนำไปคำนวณในการจัดอันดับกระดานผู้นำ\r\n\r\n3. หมายเหตุ\r\nหากการแข่งขันถูกยกเลิก เลื่อนการแข่งขัน หรือถูกตัดสินว่าไม่ถูกต้อง โอกาสในการเชียร์ ทั้งหมดที่ใช้กับแมตช์นั้นจะถูกคืนเต็มจำนวน และจะไม่นับรวมในผลการเชียร์ \r\nการปั๊มหรือแสวงหาประโยชน์จาก โอกาสในการเชียร์ ด้วยวิธีผิดปกติ หรือการใช้บั๊กใด ๆ จะส่งผลให้ โอกาสในการเชียร์ ถูกลบออก และบัญชีที่เกี่ยวข้องอาจถูกลงโทษ รวมถึงการแบนบัญชี \r\nทีมงานขอสงวนสิทธิ์ในการตีความกิจกรรมนี้เป็นที่สุด"
    },
    "record": {
      "matchTime": "จับคู่",
      "rewards": "รางวัล",
      "cheerTime": "เวลาแห่งการเชียร์",
      "cheerWinTab": "รางวัลการเชียร์",
      "milestoneTab": "รางวัลไมล์สโตน",
      "milestone": "ไมล์สโตน",
      "receiveTime": "เวลารับ",
      "target": "เป้าหมาย: "
    },
    "share": {
      "text": "แชร์",
      "title": "เชียร์การแข่งขันสำเร็จ _n_ แมตช์ และได้รับรางวัล ⚽",
      "description": "นี่ไม่ใช่เรื่องของโชค แต่มันคือสกิล ลองตามให้ทันดูสิ!!"
    },
    "mail": {
      "title": "ขอแสดงความยินดี! การเชียร์ของคุณสำเร็จแล้ว!",
      "content": "เรียนผู้เล่น\r\n\r\nขอแสดงความยินดี การเชียร์ของคุณประสบความสำเร็จในกิจกรรม [มหกรรมเชียร์บอลโลก]! ทีมที่คุณเชียร์ไว้ทำผลงานได้ตามความคาดหวังและคว้าชัยชนะมาได้สำเร็จ\r\n\r\nรางวัลสำหรับการสนับสนุนครั้งนี้ได้ถูกส่งไปยังบัญชีของคุณแล้ว กรุณาตรวจสอบ\r\n\r\nขอให้คุณมีความสุขกับการเล่นเกม\r\nทีมงาน Mini World Royale"
    },
    "item": {
      "id_70100004": "บัตรอัพเกรด Lv.3",
      "id_70100101": "เพชรทอง",
      "id_80102101": "ตั๋วทองสำหรับสุ่ม",
      "id_70100011": "ทอง",
      "id_32204003": "กล่องพิเศษระดับกลาง (7 วัน)",
      "id_70100014": "กุญแจลึกลับ",
      "id_81010999": "เหรียญพัฒนาสากล",
      "id_90501207": "ฉายา",
      "id_90301905": "กรอบไอคอน",
      "id_90105303": "รูปโปรไฟล์",
      "id_20500901": "เป้าเล็ง - ฟุตบอล",
      "id_20400904": "จี้ - นกหวีด",
      "id_90301906": "กรอบไอคอน",
      "id_90501208": "ฉายา"
    },
    "task": {
      "wc_daily_login": "ล็อกอินรายวัน",
      "wc_daily_play_mojin1": "เล่นโหมด ล่าสมบัติ 1 ครั้ง",
      "wc_daily_play_mojin3": "เล่นโหมด ล่าสมบัติ 3 ครั้ง",
      "wc_daily_play_any3": "เล่นโหมดใดก็ได้ 3 ครั้ง",
      "wc_daily_online_60m": "ออนไลน์สะสมครบ 60 นาที",
      "wc_weekly_share": "แชร์ไปยังโซเชียล",
      "daily": "ภารกิจรายวัน",
      "weekly": "ภารกิจรายสัปดาห์"
    },
    "receiveSuccess": "รับรางวัลสำเร็จ",
    "error": {
      "code1104": "หมดเวลาแล้ว",
      "code1105": "สนับสนุนการแข่งนี้แล้ว",
      "code1106": "จำนวนการสนับสนุนไม่พอ",
      "code1202": "รับรางวัลไปแล้ว",
      "code1203": "ภารกิจยังไม่เสร็จ",
      "code1302": "รับไปแล้ว",
      "code1303": "ไม่ตรงเงื่อนไข",
      "code1401": "แชร์บ่อยเกินไป",
      "code13404": "ถึงขีดจำกัดรายวันแล้ว",
      "code13405": "รหัสยืนยันหมดอายุ/ไม่ถูกต้อง",
      "code13406": "ล้มเหลวบ่อยไปในวันนี้ โปรดลองใหม่พรุ่งนี้หรือติดต่อทีมงาน",
      "code501": "ล้มเหลว ไม่พบผู้ใช้งาน",
      "code11402": "การเข้าสู่ระบบหมดอายุ",
      "code429": "ร้องขอบ่อยเกินไป โปรดลองใหม่ภายหลัง"
    },
    "mailveritify_success": "ยืนยันอีเมล์สำเร็จ"
  },
  "monopoly": {
    "rule": "กติกากิจกรรม",
    "ruleContent": "1. กิจกรรมนี้จัดขึ้นระหว่างวันที่ 15 สิงหาคม เวลา 00:00 น. ถึง 30 สิงหาคม เวลา 23:59 น. (GMT+7)\nหลังจากกิจกรรมเติมเงินสิ้นสุดลง ผู้เล่นจะไม่สามารถรับลูกเต๋าเพิ่มเติมจากการเติม เพชรสายรุ้ง ได้อีก แต่ยังสามารถใช้ลูกเต๋าที่เหลืออยู่ได้จนถึง วันที่ 6 กันยายน เวลา 23:59 น. (GMT+7)\nหลังจากเวลานี้ ผู้เล่นจะไม่สามารถใช้ลูกเต๋าที่เหลืออยู่ได้อีก และระบบจะทำการสรุปผลอันดับบนกระดานผู้นำ\nหน้ากิจกรรมจะปิดอย่างสมบูรณ์ในวันที่ 13 กันยายน เวลา 23:59 น. (GMT+7)\n2. ในช่วงเวลากิจกรรม เพียงล็อกอินเข้าสู่หน้ากิจกรรมทุกวัน รับ ลูกเต๋าธรรมดา ฟรี 1 ลูก (รับได้สูงสุด 3 ลูกตลอดกิจกรรม) \n3. เติม เพชรรุ้ง ครบทุก ๆ 100 เม็ดรับ ลูกเต๋าธรรมดา 1 ลูก และเมื่อเติมสะสมครบทุก ๆ 1,000 รับ ลูกเต๋าอเนกประสงค์ เพิ่มอีก 1 ลูก \n4. เมื่อใช้ ลูกเต๋าธรรมดา จะสุ่มจำนวนก้าวเดินตั้งแต่ 1 - 6 ช่อง \n5. ลูกเต๋าอเนกประสงค์ สามารถเลือกจำนวนแต้มได้เองตั้งแต่ 1 - 6 ก่อนเริ่มเดิน \n6. กระดานมีทั้งหมด 24 ช่อง เมื่อเดินครบ 1 รอบ ตัวละครจะกลับไปเริ่มต้นที่ จุดเริ่มต้น (เริ่ม) โดยอัตโนมัติ และระบบจะบันทึกจำนวนรอบสะสมของคุณ \n7. เมื่อหยุดที่แต่ละช่อง จะได้รับรางวัลตามช่องนั้น ๆ โดยบางช่องจะมีอีเวนต์พิเศษ โปรดตรวจสอบรายละเอียดภายในเกม \n8. เดินครบจำนวนรอบตามที่กำหนด เพื่อปลดล็อกรางวัลไมล์สโตน ยิ่งเดินครบมากเท่าไร รางวัลก็ยิ่งคุ้มค่ามากขึ้น \n9. รางวัลจัดอันดับจะอ้างอิงจาก อันดับจำนวนรอบ หลังสิ้นสุดกิจกรรม กรุณารับรางวัลก่อนหมดระยะเวลารับรางวัล \n10. รางวัลทั้งหมดบนกระดานจะถูกส่งไปยัง จดหมายในเกม หลังจากกดปุ่ม รับรางวัล รางวัลที่ไม่ได้รับก่อนกิจกรรมสิ้นสุดจะไม่สามารถขอรับย้อนหลังได้",
    "rewardRecord": "ประวัติการรับรางวัล",
    "rewardRecordDialog": {
      "reward": "รางวัล",
      "time": "เวลาที่ได้รับ",
      "status": "สถานะ",
      "statusPending": "ยังไม่ได้รับ",
      "statusExtracted": "รับแล้ว",
      "statusSent": "ส่งแล้ว",
      "empty": "ไม่มีข้อมูล"
    },
    "mainRule": "ล็อกอินทุกวัน รับลูกเต๋าฟรี 1 ลูก (รับได้สูงสุด 3 ลูกตลอดกิจกรรม)\nเติม เพชรรุ้ง ครบทุก 100 เม็ด รับลูกเต๋าเพิ่ม 1 ลูก\nเติม เพชรรุ้ง สะสมครบ 1,000 รับลูกเต๋าอเนกประสงค์ทันที 1 ลูก!",
    "logout": "ออกจากระบบ",
    "loginTitle": "ยืนยันตัวละคร",
    "accountId": "ID ตัวละคร",
    "login": {
      "logintxt": "[ล็อกอิน]",
      "inputCode": "กรอกรหัสยืนยัน",
      "sendCode": "ส่งรหัส",
      "submit": "ยืนยัน",
      "cancel": "ยกเลิก",
      "codeSent": "ส่งรหัสยืนยันแล้ว โปรดตรวจสอบกล่องจดหมายในเกม",
      "loginSuccess": "เข้าสู่ระบบสำเร็จ",
      "codeError": "เข้าสู่ระบบล้มเหลว",
      "emailPlaceholder": "กรุณากรอกบัญชี",
      "codePlaceholder": "กรอกรหัสยืนยัน"
    },
    "normalDiceNum": "ลูกเต๋าคงเหลือ: {num}",
    "universalDiceNum": "ลูกเต๋าอเนกประสงค์คงเหลือ: {num}",
    "throwOnce": "ทอย 1 ครั้ง",
    "throwAll": "ทอยทั้งหมด",
    "pleaseLogin": "กรุณาเข้าสู่ระบบก่อน",
    "noDiceTitle": "ไม่มีลูกเต๋าคงเหลือ",
    "noDiceTip1": "เติมเพชรรุ้งครบทุก ๆ {amount} เม็ด เพื่อรับ{dice} 1 ลูก",
    "noDiceTip2": "เติมเพชรรุ้งครบ{amount} เม็ด รับ{dice}เพิ่ม 1 ลูก",
    "noDiceNormal": "ลูกเต๋า",
    "noDiceUniversal": "ลูกเต๋านำโชค",
    "noDiceGoRecharge": "ไปที่หน้าเติมเงิน",
    "chooseStepsTitle": "เลือกหมายเลขลูกเต๋านำโชค",
    "chooseStepsOption": "เดินต่อ {steps} ช่อง",
    "chooseStepsConfirm": "ยืนยัน",
    "throwResultUnit": "{steps}",
    "throwAllRewardTip": "คุณใช้ลูกเต๋าทั้งหมดแล้ว (เดิน {steps} ช่อง) รับรางวัลเรียบร้อย",
    "rewardTitle": "ยินดีด้วย! คุณได้รับ",
    "rewardEmpty": "ครั้งนี้ไม่มีรางวัล",
    "mysteryEmptyTitle": "คุณมีตัวละครสุดพิเศษนี้แล้ว เปลี่ยนเป็นหีบหายากแทน",
    "boxRewardTitleNormal": "รางวัลจากหีบแรร์",
    "boxRewardTitleLucky": "รางวัลจากหีบดีลักซ์",
    "boxRewardTitleMystery": "รางวัลพิเศษฉลองครบรอบ",
    "confirm": "ยืนยัน",
    "dailyDiceClaimSuccess": "ลูกเต๋าธรรมดา +1",
    "dailyDiceTipPrefix": "ล็อกอินทุกวัน รับลูกเต๋าฟรี 1 ลูก (รับได้สูงสุด ",
    "dailyDiceTipSuffix": " ลูก)",
    "dailyDiceRemainPrefix": "รับได้อีก:",
    "dailyDiceClaim": "รับ",
    "extractRewards": "รับรางวัล",
    "extractRewardsDesc": "กดปุ่มเพื่อรับรางวัลทั้งหมดผ่านจดหมายในเกม",
    "extractSuccessTitle": "รางวัลถูกส่งไปยังเมลในเกมแล้ว",
    "noPendingRewards": "ไม่มีรางวัลให้รับ",
    "circleRewards": "เล่นให้ครบอีกจำนวนรอบเพื่อปลดล็อกรางวัลเพิ่มเติม!",
    "circleAccumulated": "จำนวนรอบทั้งหมด: {count}",
    "circleLaps": "{count} รอบ",
    "lapRewardAlready": "รับรางวัลไปแล้ว",
    "lapRewardNotReached": "ยังไม่ถึงจำนวนรอบที่กำหนด",
    "ranking": "อันดับจำนวนรอบ",
    "rankingTable": {
      "rank": "อันดับ",
      "nickname": "ชื่อตัวละคร",
      "laps": "จำนวนรอบ",
      "time": "เวลาที่ทำได้ (GMT+7)"
    },
    "rankingEmptyNickname": "ว่าง",
    "rankingRewardTitleSingle": "รางวัลอันดับ {rank}",
    "rankingRewardTitleRange": "รางวัลอันดับ {min}-{max}",
    "moveSteps": "เดินต่อ {steps} ช่อง",
    "moveStepsBack": "ถอยหลัง {steps} ช่อง",
    "moveStepsCastle": "ช่องปราสาทครบรอบ: ไปช่อง {steps}",
    "notStart": "กิจกรรมยังไม่เริ่ม",
    "ended": "กิจกรรมสิ้นสุดลงแล้ว โปรดกดรับรางวัลของท่านภายในเวลาที่กำหนด",
    "startCountdown": "นับถอยหลังเริ่มกิจกรรม",
    "rechargeCountDown": "โบนัสเติมเงินรับลูกเต๋าสิ้นสุดใน",
    "diceCountDown": "ระยะเวลาการใช้ลูกเต๋าสิ้นสุดใน",
    "countDownNotStarted": "ยังไม่เริ่มกิจกรรม",
    "countDownEnded": "สิ้นสุดแล้ว",
    "day": "วัน",
    "error": {
      "code401": "การเข้าสู่ระบบหมดอายุ",
      "code429": "ร้องขอบ่อยเกินไป โปรดลองใหม่ภายหลัง",
      "code2001": "กิจกรรมยังไม่เริ่ม",
      "code2002": "กิจกรรมสิ้นสุดแล้ว",
      "code2003": "หมดเวลารับรางวัลแล้ว",
      "code2004": "กิจกรรมสิ้นสุดแล้ว",
      "code2801": "รับลูกเต๋ารายวันไปแล้ว",
      "code2802": "ถึงขีดจำกัดการรับลูกเต๋ารายวันแล้ว",
      "code2803": "ตอนนี้ยังไม่สามารถรับลูกเต๋ารายวันได้",
      "code2901": "ไม่มีลูกเต๋าคงเหลือ",
      "code2902": "ประเภทลูกเต๋าไม่ถูกต้อง",
      "code2903": "จำนวนก้าวที่เลือกไม่ถูกต้อง",
      "code2904": "ลูกเต๋า Lucky ไม่รองรับการทอยทั้งหมด",
      "code3001": "ไม่มีรางวัลให้รับ",
      "code3002": "รับรางวัลล้มเหลว โปรดลองใหม่ภายหลัง",
      "code3101": "ยังไม่ถึงจำนวนรอบที่กำหนด",
      "code3102": "รับรางวัลไปแล้ว",
      "code3201": "ยังไม่สรุปอันดับ",
      "code3202": "รางวัลอันดับถูกส่งแล้ว"
    }
  },
  "ann2026": {
    "title": "Anniversary Ignite Plan",
    "flamePower": "ค่าพลังยิง",
    "item": {
      "70100004": "การ์ดคะแนน",
      "80102101": "ตั๋วทองสำหรับสุ่ม",
      "70100011": "ทอง",
      "70100014": "กุญแจลึกลับ",
      "70100013": "คูปองสมบัติลับ",
      "10101404": "AN94-ดอกหอมหมื่นลี้",
      "50111700": "ต้าวอุ๋ง",
      "80103001": "บัตรป้องกันอันดับ",
      "1010102006": "M4-จู่โจมสุดน่ารัก",
      "32701006": "ชุดของขวัญอุปกรณ์ขั้นสูง",
      "90301910": "【กรอบรูปโปรไฟล์】วันครบรอบ",
      "90301911": "【กรอบรูปโปรไฟล์】พายุเพลิง",
      "90501244": "【ฉายา 】เปลวไฟนิรันดร์",
      "90501245": "【ฉายา 】เพลิงฟื้นคืน",
      "81010999": "เหรียญพัฒนาสากล",
      "TBD_avatar_frame": "【กรอบรูปโปรไฟล์】วันครบรอบ",
      "TBD_title": "ฉลองครบรอบ",
      "TBD_pendant": "จี้ - นกหวีด"
    },
    "home": {
      "serverPower": "พลังไฟทั้งเซิร์ฟเวอร์"
    },
    "hero": {
      "howToPlay": "คำแนะนำกิจกรรม",
      "logout": "[ออกจากระบบ]",
      "login": "[เข้าสู่ระบบ]"
    },
    "contribute": {
      "btnMain": "ร่วมเติมพลังไฟ",
      "desc1": "รวมพลัง จุดเค้กฉลองครบรอบ!",
      "desc2": "พลังไฟที่สามารถสะสมได้: _n",
      "tabSupply": "เติมพลังไฟ",
      "tabRally": "พลแม่นปืน รวมพล!",
      "tabHistory": "ประวัติการรับรางวัล"
    },
    "dialog": {
      "close": "ปิด"
    },
    "flameSupply": {
      "title": "เติมพลังไฟ",
      "subtitle": "ทำภารกิจเพื่อรับพลัง",
      "claimed": "รับแล้ว",
      "completed": "สามารถรับได้",
      "incomplete": "ยังไม่สำเร็จ"
    },
    "eliteRally": {
      "subtitle": "ชวนเพื่อนกลับมาเพื่อรับรางวัล",
      "inviteOne": "เชิญเพื่อน 1 คน",
      "inviteMany": "เชิญเพื่อน {count} คน",
      "claimed": "รับแล้ว",
      "claim": "รับ",
      "locked": "ล็อก",
      "itemName": "ชื่อไอเทม"
    },
    "rewardHistory": {
      "title": "ประวัติการรับรางวัล",
      "reward": "รางวัล",
      "receivedAt": "เวลาที่ได้รับ"
    },
    "congratulation": {
      "receivedReward": "รับรางวัลแล้ว"
    },
    "howToPlay": {
      "body": "🎉 พลังไฟเต็มพิกัด · ภารกิจจุดเค้กฉลองครบรอบ\nดาวแห่งความมืด บุกงานฉลองและเป่าเทียนบนเค้กวันครบรอบดับหมด! ทอมและ โมนาน่า และหลิงหยูจึงรวมพลเหล่ายอดฝีมือจากทั่วเซิร์ฟเวอร์ มาร่วมส่งพลังไฟ จุดเค้กทีละชั้น และจุดเลข \"1\" เพื่อฉลองครบรอบของ Mini World Royale!\n\n📅 ระยะเวลากิจกรรม\nร่วมกิจกรรม: 15 ส.ค. - 6 ก.ย. (GMT+7)\nรับ/แลกรางวัล: ตั้งแต่เริ่มกิจกรรม - 13 ก.ย. (GMT+7)\nหมายเหตุ: กรุณารับรางวัลภายในเวลาที่กำหนด มิฉะนั้นจะถือว่าสละสิทธิ์\n\n🔥 วิธีเล่น\nขั้นที่ 1: รับจำนวนครั้งในการจุดไฟ\nเข้าเมนู เติมพลังไฟ และทำภารกิจประจำวัน เพื่อรับ จำนวนครั้งในการจุดไฟ\nอย่าลืมกลับมาทุกวัน! ยิ่งสะสมมาก ก็ยิ่งร่วมส่งพลังไฟได้มากขึ้น\n\nขั้นที่ 2: ร่วมส่งพลังไฟ จุดเค้กฉลอง\nนำจำนวนครั้งในการจุดไฟไปสะสมใน พลังไฟทั้งเซิร์ฟเวอร์\nทุกครั้งที่คุณร่วมส่ง จะช่วยเพิ่มพลังไฟให้ทั้งเซิร์ฟเวอร์ เพื่อร่วมกันจุดเค้กทั้ง 3 ชั้นให้สว่างอีกครั้ง\n\nขั้นที่ 3: ปลดล็อกรางวัล\n· รางวัลทั้งเซิร์ฟเวอร์:\nเมื่อพลังไฟทั้งเซิร์ฟเวอร์ถึง 25% / 50% / 75% / 100% จะปลดล็อกรางวัลของแต่ละขั้นให้ผู้เล่นทุกคนที่เข้าร่วม\nเมื่อพลังไฟเต็ม 100% และจุดเลข \"1\" สำเร็จ ทุกคนจะได้รับ รางวัลใหญ่ พร้อมกรอบรูปโปรไฟล์และฉายาฉลองครบรอบสุดพิเศษ\n· รางวัลส่วนตัว:\nยิ่งคุณร่วมส่งพลังไฟมากเท่าไร ก็ยิ่งปลดล็อกรางวัลไมล์สโตนส่วนตัวได้มากขึ้น\n\n🤝 รวมพลยอดฝีมือ\nชวนเพื่อนที่ห่างหายกลับมาสู่สนามรบผ่านเมนู รวมพลยอดฝีมือ\nยิ่งชวนเพื่อนกลับมาได้มาก ก็ยิ่งรับรางวัลมากขึ้น พร้อมลุ้นรับ กรอบรูปโปรไฟล์ และ ฉายาสุดพิเศษ\nมาฉลองครบรอบไปด้วยกันให้สนุกยิ่งกว่าเดิม!\n\n🏆 ประวัติรางวัล\nสามารถตรวจสอบรางวัลทั้งหมดที่ได้รับได้ที่เมนู ประวัติการรับรางวัล"
    },
    "powerContributed": {
      "text": "พลังที่มอบให้: {count}"
    },
    "task": {
      "ann_daily_login": "ล็อกอินรายวัน",
      "ann_daily_mojin_1": "เล่นโหมด ล่าสมบัติ 1 ครั้ง",
      "ann_daily_mojin_3": "เล่นโหมด ล่าสมบัติ 3 ครั้ง",
      "ann_daily_play_any_1": "เล่นโหมดใดก็ได้ 1 ครั้ง",
      "ann_weekly_share": "แชร์ไปยังโซเชียล",
      "ann_weekly_mojin_cake": "รับไอเทมหายากสีแดง \"เค้กฉลองครบรอบ\" ในโหมดล่าสมบัติ",
      "dailyLabel": "รายวัน",
      "weeklyLabel": "รายสัปดาห์"
    },
    "milestone": {
      "times": "_n ครั้ง",
      "claim": "สามารถรับได้",
      "claimed": "รับแล้ว",
      "notAchieved": "ยังไม่สำเร็จ",
      "reward_1": "Avatar Frame",
      "reward_2": "10000 card point",
      "reward_3": "2 Golden Diamond Draw Ticket",
      "reward_4": "Title",
      "reward_5": "30 Mystic Voucher",
      "reward_6": "3 Golden Diamond Draw Ticket",
      "reward_7": "6 Million Gold",
      "reward_8": "3 Golden Diamond Draw Ticket",
      "reward_9": "Pendant",
      "reward_10": "1 Mystic Key",
      "reward_11": "AN94"
    },
    "footer": {
      "privacyPolicy": "นโยบายความเป็นส่วนตัว",
      "userAgreement": "ข้อตกลงผู้ใช้",
      "customerService": "กรุณาติดต่อเราทางอีเมลที่ ministarcustomerservice{'@'}gmail.com"
    },
    "accountId": "Account ID",
    "logout": "ออกจากระบบ",
    "needLogin": "Please login to participate",
    "phase": "Phase",
    "timeRange": "Play time",
    "availableFire": "Available fire",
    "totalFire": "Total fire",
    "ignite": "Ignite",
    "share": "แชร์",
    "firstLoginReward": "Claim first login reward",
    "refresh": "Refresh",
    "receive": "รับ",
    "received": "รับแล้ว",
    "notReady": "ยังไม่สำเร็จ",
    "unlocked": "Unlocked",
    "locked": "ล็อก",
    "recallCount": "Recall count",
    "igniteOk": "Ignite success, consumed",
    "shareOk": "แชร์สำเร็จ",
    "receiveOk": "รับรางวัลสำเร็จ",
    "section": {
      "activity": "Activity info",
      "fire": "My firepower",
      "global": "Global stages",
      "task": "Tasks",
      "milestone": "Milestones",
      "recall": "Recall",
      "record": "Reward records"
    },
    "login": {
      "logintxt": "ล็อกอิน",
      "inputCode": "กรุณากรอกรหัสยืนยัน",
      "sendCode": "รหัสยืนยันถูกส่งยังเมลในเกม",
      "submit": "ยืนยัน",
      "cancel": "ยกเลิก",
      "codeSent": "ส่งรหัสยืนยันแล้ว โปรดตรวจสอบกล่องจดหมายในเกม",
      "loginSuccess": "เข้าสู่ระบบสำเร็จ",
      "emailVerificationSuccess": "ยืนยันอีเมล์สำเร็จ",
      "birthday": "สุขสันต์วันเกิด!!!",
      "codeError": "เข้าสู่ระบบล้มเหลว",
      "emailPlaceholder": "กรุณากรอกบัญชี",
      "codePlaceholder": "กรุณากรอกรหัสยืนยัน",
      "accountLabel": "ID",
      "codeLabel": "รหัสยืนยัน"
    },
    "error": {
      "code401": "การเข้าสู่ระบบหมดอายุ",
      "code2201": "ภารกิจยังไม่เสร็จ",
      "code2202": "รับรางวัลไปแล้ว",
      "code2301": "พลังไฟไม่เพียงพอ!",
      "code2401": "ยังไม่ปลดล็อกขั้นนี้",
      "code2402": "รับรางวัลไปแล้ว",
      "code2501": "ไม่ตรงเงื่อนไข",
      "code2502": "รับรางวัลไปแล้ว",
      "code2601": "จำนวนผู้เล่นที่เรียกกลับมายังไม่เพียงพอ",
      "code2602": "รับรางวัลไปแล้ว",
      "code2801": "รับรางวัลไปแล้ว",
      "code2001": "กิจกรรมยังไม่เริ่ม",
      "code2002": "กิจกรรมสิ้นสุดแล้ว",
      "code429": "ถึงขีดจำกัดรายวันแล้ว"
    }
  }
}
